export default "__VITE_ASSET__BsfnKKz8__"